var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 11,
    cy: 3.818,
    rx: 1.913,
    ry: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.911 3.818h6.24m-16.261 0h6.193"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.174,
    cy: 11,
    rx: 1.913,
    ry: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.083 11h10.068M2.89 11h2.367"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.087,
    cy: 18.182,
    rx: 1.913,
    ry: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.996 18.182h8.155m-16.261 0h4.284"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelected);
export default __webpack_public_path__ + "static/media/selected.713283df.svg";
export { ForwardRef as ReactComponent };